export const AGENT_CAN_STAKE_ROLE = 11
export const USER_SPECIAL_ROLE = 12
export const USER_AFFILIATE_ROLE = 15


export const SPECIAL_ROLE_GROUP = [AGENT_CAN_STAKE_ROLE, USER_SPECIAL_ROLE, USER_AFFILIATE_ROLE]